import { animated } from 'react-spring';
import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Overlay = styled.div`
  position: fixed;
  display: flex;

  height: 100%;
  width: 100%;

  flex: 1;

  justify-content: center;
  align-items: center;

  padding: 24px;

  background-color: ${colors.surface}b3;
  backdrop-filter: blur(4px);

  z-index: 500;

  @media (max-width: 1199px) {
    padding: 0;
  }
`;

export const Container = styled(animated.div)`
  position: absolute;
  overflow: hidden;

  width: auto;
  max-width: calc(100vw - 48px);

  max-height: 90vh;
  overflow-y: auto;

  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
  border-radius: ${radius.lg};
  border: 1px solid ${colors.outlineVariant}40;

  background-color: ${colors.surfaceContainerLow};

  z-index: 1000;

  @media (max-width: 1199px) {
    width: 90%;
    max-width: 90%;
  }
`;
